import {
  AgroRiskType,
  ChronicRiskType,
  NotificationEventItem,
  ProtectionActionItem,
  ProtectionRiskType,
} from "@bienesis/common";

import { ProtectionKey } from "@/sheets/enums/protection-key.enum";

export type { ProtectionRiskType };
export { AgroRiskType, ChronicRiskType };

// Date fields arrive as ISO strings over HTTP
export type NotificationEventItemHttp = Omit<NotificationEventItem, "occurredAt"> & {
  occurredAt: string;
};

export type ProtectionActionItemHttp = Omit<
  ProtectionActionItem,
  "commandSentAt" | "commandReceivedByGatewayAt"
> & {
  commandSentAt: string;
  commandReceivedByGatewayAt: string | null;
};

type PaginatedPayload<T> = {
  items: T[];
  total: number;
  hasMore: boolean;
};

export type AreaProtectionSummaryHttp = {
  activeSince: string | null;
  notificationEvents: PaginatedPayload<NotificationEventItemHttp>;
  protectionActions: PaginatedPayload<ProtectionActionItemHttp>;
};

export type ActiveProtectionHttp = {
  riskType: ProtectionRiskType;
  activatedAt: string;
};

export type ActiveProtectionsResultHttp = {
  externalId: string;
  protections: ActiveProtectionHttp[];
};

export const PROTECTION_KEY_TO_RISK_TYPE: Record<ProtectionKey, ProtectionRiskType> = {
  [ProtectionKey.HAIL]: ChronicRiskType.HAIL,
  [ProtectionKey.WIND]: ChronicRiskType.HIGH_WIND,
  [ProtectionKey.HEAT]: AgroRiskType.HEAT_STRESS,
  [ProtectionKey.DROUGHT]: AgroRiskType.WATER_STRESS,
  [ProtectionKey.FROST]: AgroRiskType.FROST_RISK,
  [ProtectionKey.CONTAMINATING_RAIN]: AgroRiskType.DISEASE_INDUCING_RAIN,
  [ProtectionKey.LEACHING_RAIN]: AgroRiskType.RAIN_WASH_OFF,
};
